import {
  GET_CURRENCY,
  SET_CURRENCY,
  CURRENCY_ERROR,
  LOADING_CURRENCY
} from "../actions/types";

const initialState = {
  currency: "",
  loading: false,
  error: {}
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CURRENCY:
      return {
        ...state,
        currency: payload,
        loading: false
      };
    case SET_CURRENCY:
      return {
        ...state,
        currency: payload,
        loading: false
      };
    case LOADING_CURRENCY:
      return { ...state, loading: true };
    case CURRENCY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
};
